/**
 * announce slider
 */
$(function(){
	let mainSwiper = new Swiper( '#main-swiper', {
		effect: 'slide',
		loop: true,			// true
		speed: 600,
		spaceBetween: 0,
		slidesPerView: 'auto',
		preloadImages: true,
	    autoplay: {
	      delay: 10000,
	      stopOnLast: false,
	      disableOnInteraction: true
	    },
	});
});